import './pictureFrame.scss';

function PictureFrame({ children }) {
  return (
    <div className='box-img'>
      <div className='box-img__holder'>{children}</div>
    </div>
  );
}

export default PictureFrame;
